// extracted by mini-css-extract-plugin
export var container = "Header-module--container--0bfw7";
export var fixed = "Header-module--fixed--OeU6g";
export var globe = "Header-module--globe--U9Dy7";
export var langButton = "Header-module--langButton--CmoVy";